
import { defineComponent } from "vue";
import Container from "@/components/atoms/Container.vue";
import Hero from "@/components/molecules/Hero.vue";
import ProductGrid from "@/components/organisms/ProductGrid.vue";

export default defineComponent({
  name: "Home",
  computed: {
    items() {
      return this.$store.getters.getFeaturedProducts;
    }
  },
  components: {
    Hero,
    Container,
    ProductGrid
  }
});
